<template>
  <div class="zk-shell" :class="{ 'zk-shell--widget': isWidget }">
    <TheTopbar v-if="!isWidget" />

    <main class="zk-shell__content" :class="{ 'zk-shell__content--tabbed': showTabbar }">
      <router-view :key="routeKey" />
    </main>

    <!-- Мобильный тап-бар: только верхнеуровневый список форм;
         в отличие от topbar работает и в iframe/WebView мини-аппа -->
    <MobileTabBar v-if="showTabbar" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import LifeBridge from '@tnlife/tn-bridge';
import { setDarkTheme } from '@life_uikit/uikit/helpers';
import TheTopbar from '@/components/layout/TheTopbar.vue';
import MobileTabBar from '@/components/layout/MobileTabBar.vue';

const route = useRoute();

// Тап-бар — только на верхнеуровневом экране (список форм); в билдере,
// результатах и заполнении место дорого и случайный тап уводит из контекста.
const showTabbar = computed(() => route.name === 'forms');

// Ключ для router-view: для маршрутов формы — по имени+id, чтобы переход между
// табами одной формы (Конструктор ↔ Настройки ?tab=settings) НЕ перемонтировал
// view и не дёргал шапку. Для остальных — по полному пути.
const routeKey = computed<string>(() => {
  const id = route.params.id;
  return id ? `${String(route.name)}:${String(id)}` : route.fullPath;
});

// Топбар скрыт только на маршрутах meta.widget (публичное заполнение).
// В обоих режимах мини-аппа (iframe и WebView) топбар показываем: суперап
// прячет свою шапку после инициализации и накладывает плавающие пилюли —
// наш топбар занимает эту полосу (профиль в нём скрыт — см. TheTopbar).
const isWidget = computed(() => !!(route.meta?.widget));

onMounted(() => {
  // Восстанавливаем тему из localStorage (dev)
  const saved = localStorage.getItem('forms-theme');
  if (saved === 'dark') {
    setDarkTheme('dark');
    document.documentElement.classList.add('tn-dark-theme');
    document.body.classList.add('tn-dark-theme');
  }
});
</script>

<style scoped>
.zk-shell {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--background-tertiary-enabled, var(--neutral-20));
}

.zk-shell__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: clip;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.zk-shell--widget .zk-shell__content {
  background: var(--background-tertiary-enabled, var(--neutral-20));
}

@media (max-width: 768px) {
  .zk-shell__content--tabbed {
    padding-bottom: calc(64px + env(safe-area-inset-bottom, 0px));
  }
}
</style>
